import { formatNumber } from '../../../utils/format';

export interface FlowActivityCounts {
  calls?: number;
  sms?: number;
  email?: number;
}

const CHANNELS: { key: keyof FlowActivityCounts; label: string }[] = [
  { key: 'calls', label: 'Calls' },
  { key: 'sms', label: 'SMS' },
  { key: 'email', label: 'Email' },
];

export function flowActivityTotal(counts: FlowActivityCounts): number {
  return CHANNELS.reduce((sum, { key }) => sum + (counts[key] ?? 0), 0);
}

/** "Calls 120 · SMS 340 · Email 85" — only the channels the flow used. */
export function flowActivityBreakdown(counts: FlowActivityCounts): string {
  return CHANNELS.filter(({ key }) => (counts[key] ?? 0) > 0)
    .map(({ key, label }) => `${label} ${formatNumber(counts[key])}`)
    .join(' · ');
}
